import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../shared/context/auth-context";
import moment from "moment";
import ModalAdicionarEvolucao from "./ModalAdicionarEvolucao/ModalAdicionarEvolucao";
import ModalEditarEvolucao from "./ModalEditarEvolucao/ModalEditarEvolucao";
import ModalEvolucao from "./ModalEvolucao";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ModalInfo from "../../../../../shared/components/UIElements/ModalInfo";
import toast from "react-hot-toast";
import "./Historico.scss";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import BadgeUnidade from "../../../../../shared/components/badgeUnidade/BadgeUnidade";


import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Alert,
  Box,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import ModalEditarTratamentoIsolado from "./ModalEditarTratamentoIsolado/ModalEditarTratamentoIsolado";
import HistoricoTimeline from "./HistoricoTimeline";

/* Motivos guardados como constante no servidor. Sem isto o histórico mostrava
   CRIANCA_NAO_COLABOROU tal e qual. */
const MOTIVOS_NAO_EXECUCAO = {
  CRIANCA_NAO_COLABOROU: "A criança não colaborou",
  PACIENTE_NAO_COLABOROU: "O paciente não colaborou",
  CONDICAO_CLINICA_INADEQUADA: "Condição clínica inadequada",
  EQUIPAMENTO_INDISPONIVEL: "Equipamento indisponível",
  OUTRO: "Outro motivo",
};

/**
 * Primeiro e último nome. Os nomes completos são longos de mais para a coluna e
 * partiam a linha; o primeiro e o apelido chegam para identificar quem é.
 */
const nomeCurto = (nome) => {
  if (!nome) return "—";
  const partes = nome.trim().split(/\s+/);
  return partes.length > 1
    ? `${partes[0]} ${partes[partes.length - 1]}`
    : partes[0];
};

/* Onde o procedimento foi executado.
 *
 * É a unidade da SESSÃO, não a do plano: um plano orçamentado num balcão pode
 * ter sessões executadas noutro, e o que interessa a quem lê o histórico é
 * onde o trabalho foi feito.
 *
 * Devolve as unidades DISTINTAS porque um procedimento tem várias sessões e
 * elas podem não ser todas do mesmo sítio — mostrar só a primeira esconderia
 * precisamente o caso que vale a pena ver. */
const unidadesDasSessoes = (sessoes = []) => {
  const vistas = new Map();
  for (const s of sessoes) {
    const u = s?.estabelecimento;
    if (u?._id && !vistas.has(String(u._id))) vistas.set(String(u._id), u);
  }
  return [...vistas.values()];
};

function Historico({ clienteId, sendRequest, clienteData }) {
  const { startLoading, stopLoading } = useLoading();

  const [planosTratamento, setPlanosTratamento] = useState();
  const [modalData, setModalData] = useState();
  const [evolucoes, setEvolucoes] = useState();
  const [tratamentoIsolados, setTratamentoIsolados] = useState();
  // Atendimentos em que o paciente veio mas nada foi executado. Não geram
  // sessão, por isso não apareciam em lado nenhum do histórico.
  const [naoExecutados, setNaoExecutados] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const auth = useContext(AuthContext);

  useEffect(() => {
    const sortedEvolucoes = [...clienteData.evolucoes].sort((a, b) => {
      return new Date(b.data_fim_execucao) - new Date(a.data_fim_execucao);
    });

    setEvolucoes(sortedEvolucoes);
  }, [clienteData]);

  const [modalProps, setModalProps] = useState({
    show: false,
    icon: "",
    title: "",
    message: "",
    form: false,
  });

  useEffect(() => {
    const fetchPlanosTratamentoByCliente = async () => {
      startLoading();
      try {
        let responseData;
        let responseDataTratamentoIsolado;
        try {
          responseData = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/historico/${clienteId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
        } catch (err) {
          console.error("err", err);
        }

        try {
          responseDataTratamentoIsolado = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/tratamentoIsolados/executadas/cliente/${clienteId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
        } catch (err) {
          console.error("err", err);
        }

        try {
          const respNaoExecutados = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/atendimentosnaoexecutados/${clienteId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
          setNaoExecutados(respNaoExecutados?.atendimentos || []);
        } catch (err) {
          console.error("err", err);
        }

        const tempTratamentoIsolados =
          responseDataTratamentoIsolado.tratamentoIsolados.sort((a, b) => {
            return (
              new Date(b.data_inicio_execucao) -
              new Date(a.data_inicio_execucao)
            );
          });

        const temp = responseData.planosTratamento.sort((a, b) => {
          return new Date(b.data_inicio) - new Date(a.data_inicio);
        });

        temp.forEach((plano) => {
          if (plano.data_inicio) {
            plano.data_inicio = moment(plano.data_inicio).format("DD-MM-YYYY");
          }
          if (plano.data_fim) {
            plano.data_fim = moment(plano.data_fim).format("DD-MM-YYYY");
          }
        });

        setTratamentoIsolados(tempTratamentoIsolados);
        setPlanosTratamento(temp);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchPlanosTratamentoByCliente();
  }, [sendRequest, clienteId, auth]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleShowEvolucao = (proc, idPlano) => {
    setModalData({ open: "evolucao", data: { proc: proc, idPlano: idPlano } });
  };

  const handleCloseModal = () => {
    setModalData();
  };

  const handleOpenModalAdicionarEvolucao = () => {
    setModalData({ open: "adicionarEvolucao" });
  };

  const handleModalSubmitSuccess = (evolu) => {
    handleCloseModal();
    setEvolucoes((current) => [...current, evolu]);
  };

  const handleModalEditarSuccess = (evolu) => {
    handleCloseModal();

    setEvolucoes((prevItems) =>
      prevItems.map((item) => (item.id === evolu.id ? { ...evolu } : item)),
    );
  };

  const handleModalCancel = () => {
    setModalProps((currentModalProps) => {
      return { ...currentModalProps, show: false };
    });
  };

  const handleApagarEvolucao = async (idEvolucao) => {
    setModalProps({
      show: true,
      icon: "info",
      title: `Eliminar Evolução!`,
      message: `Tem a certeza que pretende eliminar a evolução?`,
      form: true,
      onCancel: handleModalCancel,
      onConfirm: apagarEvolucao.bind(null, idEvolucao),
    });
  };

  const apagarEvolucao = async (idEvolucao) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("usuario", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/apagarevolucao/${idEvolucao}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );
      toast.success("Evolução eliminada com sucesso");
      setEvolucoes((current) => current.filter((c) => c.id !== idEvolucao));
    } catch (err) {
      console.error("err", err);
      console.error(err);
    } finally {
      stopLoading();
      handleModalCancel();
    }
  };

  const handleOpenModalEditar = async (idEvolucao) => {
    setModalData({
      open: "editarEvolucao",
      data: evolucoes.find((ev) => ev.id === idEvolucao),
    });
  };

  const updatePlanosTratamento = (newPlano) => {
    const tempNovosPlanos = [...planosTratamento].map((p) =>
      p._id === newPlano._id ? newPlano : p,
    );

    const temp = tempNovosPlanos.sort((a, b) => {
      return new Date(b.data_inicio) - new Date(a.data_inicio);
    });

    temp.forEach((plano) => {
      if (plano.data_inicio) {
        plano.data_inicio = moment(plano.data_inicio).format("DD-MM-YYYY");
      }
      if (plano.data_fim) {
        plano.data_fim = moment(plano.data_fim).format("DD-MM-YYYY");
      }
    });

    setPlanosTratamento(temp);
  };

  const handleShowTratamentoIsolado = (id) => {
    const tratamentoIsoladoFiltrada = tratamentoIsolados.find(
      (c) => c._id === id,
    );
    if (!tratamentoIsoladoFiltrada) {
      toast.error("Dados do tratamento Isolado não encontrados!");
      return;
    }

    /* O relatório é o registo clínico de quem executou, e só essa pessoa o
       corrige — como já acontece nas evoluções aqui em baixo. Qualquer
       utilizador com acesso à ficha conseguia abrir isto e reescrever o
       relatório de outro médico. */
    if (tratamentoIsoladoFiltrada.medico?._id !== auth.userId) {
      toast.error(
        `Só ${tratamentoIsoladoFiltrada.medico?.name || "o médico que executou"} pode editar este relatório.`,
      );
      return;
    }
    setModalData({
      open: "editarTratamentoIsolado",
      data: tratamentoIsoladoFiltrada,
    });
  };

  const handleEditarTratamentoIsoladoSuccess = (tratamentoIsoladoRetornada) => {
    handleCloseModal();
    setTratamentoIsolados((current) =>
      current.map((c) =>
        c._id === tratamentoIsoladoRetornada._id
          ? tratamentoIsoladoRetornada
          : c,
      ),
    );
  };

  const hasSessions = (planoTratamento) => {
    // Check if any procedimento has sessions
    const hasSessions = planoTratamento.procedimentos.some(
      (procedimento) => procedimento.sessoes && procedimento.sessoes.length > 0,
    );

    // Return true only if there are sessions
    return hasSessions;
  };

  return (
    <>
      <ModalInfo {...modalProps} />

      {/* Sistema de Abas */}
      <Box sx={{ width: "100%", mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="historico tabs"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 600,
              minHeight: "48px",
            },
          }}
        >
          <Tab label="Visão Detalhada" />
          <Tab label="Timeline Cronológica" />
        </Tabs>
      </Box>

      {/* Conteúdo da Aba 0 - Visão Detalhada */}
      {tabValue === 0 && (
        <>
          {planosTratamento && planosTratamento.length > 0 && (
            <div
              className="historicoContainer caixa"
              style={{ marginBottom: "25px" }}
            >
              {planosTratamento.map((plano) => (
                <Accordion
                  key={plano._id}
                  defaultExpanded={
                    !plano.contaLiquidada &&
                    plano.total !== 0 &&
                    plano.status !== "INTERROMPIDO"
                  }
                  sx={{
                    mb: 2,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "2rem",
                          "&:hover": {
                            transform: "scale(1.2)",
                            color: "primary.main",
                            filter: "brightness(1.2)",
                            transition: "all 0.2s ease-in-out",
                          },
                        }}
                      />
                    }
                    sx={{
                      height: "55px",
                      backgroundColor:
                        plano.status === "INTERROMPIDO" ? "#fff8f8" : "#fdfdfd",
                      borderLeft:
                        plano.status === "INTERROMPIDO"
                          ? "4px solid #eb3c5f"
                          : "4px solid #4caf50",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        {(plano.data_inicio || plano.data_fim) && (
                          <span className="debitos__accordion__title">
                            Plano de Tratamento {plano.numero} -{" "}
                            {plano.data_inicio ? plano.data_inicio : "?"} a{" "}
                            {plano.data_fim ? plano.data_fim : "?"}
                          </span>
                        )}
                        {plano.status === "INTERROMPIDO" && (
                          <>
                            <span className="debitos__accordion__title">
                              Plano de Tratamento {plano.numero} -
                            </span>
                            <Chip
                              label="Tratamento Interrompido"
                              size="small"
                              sx={{
                                color: "#eb3c5f",
                                backgroundColor: "rgba(241, 167, 182, 0.47)",
                              }}
                            />
                          </>
                        )}

                        {hasSessions(plano) === false && (
                          <>
                            <span className="debitos__accordion__title">
                              Plano de Tratamento {plano.numero} -
                            </span>
                            <Chip
                              label="Por iniciar"
                              size="small"
                              sx={{
                                color: "#fdcb7f",
                                backgroundColor: "#fff7eb",
                              }}
                            />
                          </>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails>
                    {plano.status === "INTERROMPIDO" &&
                      plano.motivoEncerramento && (
                        <Alert
                          severity="info"
                          sx={{ mb: 2 }}
                          icon={
                            plano.motivoEncerramento?.descricao ? (
                              <Tooltip
                                title={plano.motivoEncerramento?.descricao}
                              >
                                <InfoIcon sx={{ cursor: "help" }} />
                              </Tooltip>
                            ) : (
                              <InfoIcon />
                            )
                          }
                        >
                          <Typography variant="body2">
                            <strong>Motivo da Interrupção:</strong>{" "}
                            {plano.motivoEncerramento?.tipo}
                            <br />
                            <div style={{ marginTop: "7px" }}>
                              <strong>Data:</strong>{" "}
                              {moment(plano.motivoEncerramento?.data).format(
                                "DD-MM-YYYY",
                              )}{" "}
                              <strong style={{ marginLeft: "15px" }}>
                                Responsável:{" "}
                              </strong>
                              {plano.motivoEncerramento?.responsavel?.name}
                            </div>
                          </Typography>
                        </Alert>
                      )}

                    <div className="historico__colapse-container">
                      <div className="historico__colapse-container__row--header">
                        <span>Data Inicio</span>
                        <span>Procedimento</span>
                        <span>Sessões</span>
                        <span>Dentes</span>
                        <span>Faces</span>
                        <span>Estado</span>
                      </div>

                      {plano.procedimentos.map(
                        (proc, idx) =>
                          proc.sessoes.length > 0 && (
                            <div
                              className="historico__colapse-container__row caixa"
                              key={idx}
                            >
                              <div className="historico__colapse-container__row__item">
                                <span>
                                  {proc.data_inicio_execucao
                                    ? moment(proc.data_inicio_execucao).format(
                                        "DD-MM-YYYY",
                                      )
                                    : moment(
                                        proc.sessoes[0].data_inicio_execucao,
                                      ).format("DD-MM-YYYY")}
                                </span>
                              </div>
                              <div className="historico__colapse-container__row__item">
                                <span
                                  className="historico__colapse-container__row__item--tratamento"
                                  onClick={() =>
                                    handleShowEvolucao(proc, plano._id)
                                  }
                                >
                                  {proc.tratamento.designacao}
                                </span>{" "}
                                {/* Onde foi executado. Várias pastilhas quando
                                    as sessões foram feitas em unidades
                                    diferentes. */}
                                {unidadesDasSessoes(proc.sessoes).map((u) => (
                                  <BadgeUnidade
                                    key={u._id}
                                    estabelecimento={u}
                                    prefixo="Executado em"
                                  />
                                ))}
                              </div>
                              <div className="historico__colapse-container__row__item">
                                {proc.sessoes ? proc.sessoes.length : 1}
                              </div>
                              <div className="historico__colapse-container__row__item">
                                {proc.dente}
                              </div>
                              <div className="historico__colapse-container__row__item">
                                {proc.faces.join(", ")}
                              </div>
                              <div
                                className="historico__colapse-container__row__item"
                                style={{}}
                              >
                                <span
                                  className={`historicoStatus ${
                                    proc.procedimento_completo
                                      ? "historicoStatusConcluido"
                                      : proc.sessoes.length > 0
                                        ? "historicoStatusTransformado"
                                        : ""
                                  }`}
                                >
                                  {proc.procedimento_completo
                                    ? "Finalizado"
                                    : proc.sessoes.length > 0
                                      ? "Em Andamento"
                                      : ""}
                                </span>
                              </div>
                            </div>
                          ),
                      )}

                      {!plano.procedimentos.filter((p) => p.sessoes.length > 0)
                        .length > 0 && (
                        <div className="historico__noDataMessage">
                          Nenhum procedimento iniciado nesse plano. Sem dados
                          por mostrar!
                        </div>
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          )}

          {tratamentoIsolados && tratamentoIsolados.length > 0 && (
            <div className="historicoContainer caixa">
              <Accordion
                defaultExpanded
                sx={{
                  mb: 2,
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        fontSize: "2rem",
                        "&:hover": {
                          transform: "scale(1.2)",
                          color: "primary.main",
                          filter: "brightness(1.2)",
                          transition: "all 0.2s ease-in-out",
                        },
                      }}
                    />
                  }
                  sx={{
                    height: "55px",
                    backgroundColor: "#eafdff",
                    borderLeft: "4px solid #00BCD4",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <span className="debitos__accordion__title">
                        Tratamentos Isolados
                      </span>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails>
                  <div className="historico__colapse-container">
                    <div className="historico__colapse-container__tratamentoIsolado__row--header">
                      <span>Tratamento</span>
                      <span>Dentes</span>
                      <span>Faces</span>
                      <span>Médico</span>
                      <span>Data Início</span>
                      <span>Data Fim</span>
                      <span>Estado</span>
                    </div>

                    {tratamentoIsolados.map((tratamentoIsolado, index) => (
                      <div
                        className="historico__colapse-container__tratamentoIsolado__row caixa"
                        key={index}
                      >
                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span
                            className="historico__colapse-container__tratamentoIsolado__row__item--tratamento"
                            onClick={handleShowTratamentoIsolado.bind(
                              null,
                              tratamentoIsolado._id,
                            )}
                          >
                            {tratamentoIsolado.tratamento?.designacao
                              ? tratamentoIsolado.tratamento.designacao
                              : tratamentoIsolado.categoriaTratamento?.categoria
                                ? tratamentoIsolado.categoriaTratamento
                                    ?.categoria
                                : "N/A"}
                          </span>{" "}
                          {/* Onde foi executado. Num isolado a unidade está no
                              próprio registo — não há sessões, o tratamento é
                              o atendimento. */}
                          <BadgeUnidade
                            estabelecimento={tratamentoIsolado.estabelecimento}
                            prefixo="Executado em"
                          />
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span>
                            {tratamentoIsolado.dente
                              ? tratamentoIsolado.dente
                              : ""}
                          </span>
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span>
                            {tratamentoIsolado.faces
                              ? tratamentoIsolado.faces.join(" ,")
                              : ""}
                          </span>
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span>{tratamentoIsolado.medico.name}</span>
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span>
                            {moment(
                              tratamentoIsolado.data_inicio_execucao,
                            ).format("DD-MM-YYYY HH:mm")}
                          </span>
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span>
                            {moment(tratamentoIsolado.data_fim_execucao).format(
                              "DD-MM-YYYY HH:mm",
                            )}
                          </span>
                        </div>

                        <div className="historico__colapse-container__tratamentoIsolado__row__item">
                          <span className="historicoStatus  historicoStatusConcluido">
                            Executado
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          )}

          {naoExecutados.length > 0 && (
            <div className="historicoContainer caixa">
              <Accordion
                defaultExpanded
                sx={{
                  mb: 2,
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        fontSize: "2rem",
                        "&:hover": {
                          transform: "scale(1.2)",
                          color: "primary.main",
                          filter: "brightness(1.2)",
                          transition: "all 0.2s ease-in-out",
                        },
                      }}
                    />
                  }
                  sx={{
                    height: "55px",
                    backgroundColor: "#fff1f2",
                    borderLeft: "4px solid #ef4444",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <span className="debitos__accordion__title">
                        Atendimentos sem execução
                      </span>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails>
                  <div className="historico__colapse-container">
                    <div className="historico__naoexecutado__row--header">
                      <span>O que estava marcado</span>
                      <span>Médico</span>
                      <span>Data</span>
                      <span>Motivo</span>
                    </div>

                    {naoExecutados.map((at) => (
                      <div
                        className="historico__naoexecutado__row caixa"
                        key={at.id}
                      >
                        <span>{at.designacao}</span>
                        <span>{nomeCurto(at.medico?.name)}</span>
                        <span>
                          {moment(at.data_inicio_execucao).format(
                            "DD/MM/YYYY HH:mm",
                          )}
                        </span>
                        <span>
                          {MOTIVOS_NAO_EXECUCAO[at.motivoNaoExecucaoTipo] ||
                            at.motivoNaoExecucaoTipo ||
                            "—"}
                          {at.motivoNaoExecucaoDetalhes && (
                            <em className="historico__naoexecutado__detalhes">
                              {" - "}
                              {at.motivoNaoExecucaoDetalhes}
                            </em>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          )}

          {(auth.role === "Dentista" ||
            auth.role === "Médico/Administrador") && (
            <div className="adicionarEvolucaoButtonContainer">
              <span
                className="blue-button"
                onClick={handleOpenModalAdicionarEvolucao}
              >
                Adicionar Evolução
              </span>
            </div>
          )}

          {evolucoes && (
            <div className="evolucaoClienteSolo__container">
              {evolucoes.map((ev, index) => (
                <div className="caixa evolucaoItemContainer" key={index}>
                  <div className="evolucaoClienteSolo">
                    <span className="evolucao-descricao">{ev.evolucao}</span>
                    <div>
                      <span className="evolucao-datas">
                        {moment(ev.data_inicio_execucao).format(
                          "DD/MM/YYYY HH:mm",
                        )}
                      </span>{" "}
                      {"  -  "}
                      <span className="evolucao-datas">
                        {moment(ev.data_fim_execucao).format("HH:mm")} -{" "}
                        {ev.medico ? ev.medico.name : ""}
                      </span>
                    </div>
                  </div>
                  <div className="evolucao-btns">
                    {ev.medico?._id === auth.userId && (
                      <>
                        <Tooltip title="Apagar">
                          <IconButton
                            onClick={handleApagarEvolucao.bind(null, ev._id)}
                            className="modalEvolucao__container__btns__icon-btn"
                          >
                            <DeleteIcon className="evolucao-btns__btn" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                          <IconButton
                            onClick={handleOpenModalEditar.bind(null, ev._id)}
                            className="modalEvolucao__container__btns__icon-btn"
                          >
                            <EditIcon className="evolucao-btns__btn" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Conteúdo da Aba 1 - Timeline Cronológica */}
      {tabValue === 1 && (
        <div className="caixa" style={{ padding: "20px" }}>
          <HistoricoTimeline
            planosTratamento={planosTratamento}
            tratamentoIsolados={tratamentoIsolados}
            evolucoes={evolucoes}
            naoExecutados={naoExecutados}
          />
        </div>
      )}

      {modalData?.open === "evolucao" && (
        <ModalEvolucao
          data={modalData.data}
          openModalEvolucao={modalData.open === "evolucao"}
          handleCloseModal={handleCloseModal}
          auth={auth}
          sendRequest={sendRequest}
          updatePlanosTratamento={updatePlanosTratamento}
        />
      )}

      {modalData?.open === "editarTratamentoIsolado" && (
        <ModalEditarTratamentoIsolado
          dados={modalData.data}
          open={modalData.open === "editarTratamentoIsolado"}
          handleCloseModal={handleCloseModal}
          auth={auth}
          sendRequest={sendRequest}
          handleModalSubmitSuccess={handleEditarTratamentoIsoladoSuccess}
        />
      )}

      {modalData?.open === "adicionarEvolucao" && (
        <ModalAdicionarEvolucao
          handleCloseModalEvolucao={handleCloseModal}
          handleModalSubmitSuccess={handleModalSubmitSuccess}
          open={modalData.open === "adicionarEvolucao"}
          cliente={{ nome: clienteData.nome, id: clienteData.id }}
          sendRequest={sendRequest}
          auth={auth}
        />
      )}

      {modalData?.open === "editarEvolucao" && (
        <ModalEditarEvolucao
          handleCloseModalEvolucao={handleCloseModal}
          handleModalEditarSuccess={handleModalEditarSuccess}
          open={modalData.open === "editarEvolucao"}
          cliente={{ nome: clienteData.nome, id: clienteData.id }}
          sendRequest={sendRequest}
          auth={auth}
          dadosEvolucao={modalData.data}
        />
      )}
    </>
  );
}

export default Historico;
